import * as yup from "yup";

const validation = (messages, { isRia, isProfessional }) => {
  return yup.object().shape({
    professionalPaymentAccount:
      isProfessional &&
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE),
    electronicSignatureEligibility:
      isRia &&
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE),
    paymentAccount:
      !isProfessional &&
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE),
  });
};

export default validation;
